//
//
//
//
//
//
//
//
//
//
//
//
//

import { Paper } from '@backmarket/design-system'

import RateSection from '../RateSection'
import Stats from '../Stats'

export default {
  components: {
    Paper,
    Stats,
    RateSection,
  },
  props: {
    globalRate: {
      type: Number,
      required: true,
    },
    totalReviews: {
      type: Number,
      required: true,
    },
    statsInfo: {
      type: Array,
      required: true,
    },
  },
}
